import { Container, Flex, Text } from '@chakra-ui/react';
import { PeriodTile, Footer, Tabs } from 'components';
import { PERIODS } from 'data';
import { FlightDetailsTab } from './Tabs';

const tabList = [{
    id: 1,
    titleContent: <Flex align='center' width={200}><Text  marginRight={10} padding={1}>1.</Text>Flight Details<Text></Text></Flex>,
    content:<FlightDetailsTab />
  },
  {
    id: 2,
    titleContent: <Flex align='center' width={250}><Text  marginRight={10} padding={1}>2.</Text><Text>Passenger Details</Text></Flex>,
    content: <></>
  },
  {
    id: 3,
    titleContent: <Flex align='center' width={200}><Text  marginRight={10} padding={1}>3.</Text>Review<Text></Text></Flex>,
    content: <></>
  },
  {
    id: 4,
    titleContent: <Flex align='center' width={200}><Text  marginRight={10} padding={1}>4.</Text>Payment<Text></Text></Flex>,
    content: <></>
  }];
const TicketsAirplane = () => {
  return (
    <>
      <Container marginLeft='20%' padding={0} marginRight={0}>
        <PeriodTile dates={PERIODS} onClick={function (id: number): void {
                  throw new Error('Function not implemented.');
              } } />
        <Flex width='100%' marginTop={10}>
            <Tabs tabList={tabList} alignment="space-between"/>
        </Flex>
      </Container>
      <Footer />
    </>
  );
};

export { TicketsAirplane };
